<template>
<v-container fluid>
    <div v-if="startInit">{{initData()}}</div>

    <div v-if="messageList && messageList.length > 0" class="mb-6">
      <!-- <v-flex xs12> -->
        <v-card class="border-radius-md card-border-style shadow-none overflow-hidden">
            <v-toolbar class="white--text only-b-t-radius-md cursor-pointer" dense v-if="messageList" @click="messagesShowed = !messagesShowed">
            <v-toolbar-title>Messages</v-toolbar-title>
            <v-icon v-if="!messagesShowed" class="margin-left-auto white--text">expand_more</v-icon>
            <v-icon v-if="messagesShowed" class="margin-left-auto white--text">expand_less</v-icon>
          </v-toolbar>
          <v-container fluid class="leaderboard pt0" v-if="messageList && messagesShowed">
            <MessageList v-bind:messageList='messageList'/>  
            <div class="mt10 text-align-right">
              <v-btn dense @click="showMessages()" class="btn-style btn-primary">All messages... </v-btn>
            </div>
          </v-container>
        </v-card>
      <!-- </v-flex> -->
    </div>
    <v-toolbar  color="secondary" class="mb-6 white--text" dense >
      <v-toolbar-title v-if="!isAdmin">My courses</v-toolbar-title>
      <v-toolbar-title v-if="isAdmin">Categories</v-toolbar-title>
    </v-toolbar>
        <v-row v-if="!isAdmin && courseList" class="mb-6 course-dashboard-list">
            <!-- <v-card raised  v-for="(course,index) in courseList" :key="index" class="ms-3 mb-6" @click="showCourse(course)" min-width="25em">    -->
            
            <!-- cols="default number of columns/xs" -->
            <v-col v-for="(course,index) in courseList" :key="index" cols="12" sm="6" md="4" lg="3" xl="2" class="course-dashboard-list__item"> 
              <v-card raised @click="showCourse(course)">  
                  <v-card-title primary-title class="layout justify-center course-dashboard-list__course-title" :style="getStyle(courseList[index].area_color)">
                    <span>{{course.name}}</span>
                  </v-card-title>
                    <v-card-text>
                      <v-row> 
                          <v-col cols="12" class="course-dashboard-list__course-description">
                               <span v-if="course.description"> {{course.description}}</span>
                               <span v-else> . </span> 
                          </v-col>
                      </v-row>
                        <v-row> 
                          <v-col cols="4">
                                <v-icon :color="course.area_color" class="material-icons-outlined" large>description</v-icon> <br/>
                                <b>{{course.content_passed}} / {{course.content_count}} </b>
                          </v-col>
                          <v-col cols="4">
                                <v-icon :color="course.area_color" class="material-icons-outlined" large>contact_support</v-icon> <br/>
                                <b> {{course.task_passed}} / {{course.task_count}}</b>
                          </v-col>
                          <v-col cols="4">
                                <v-icon :color="course.area_color" class="material-icons-outlined" large>code </v-icon> <br/>
                                 <b>{{course.program_passed}} / {{course.program_count}}</b>
                          </v-col>
                        </v-row>
                    </v-card-text> 
                    
                    <v-card-actions class="course-dashboard-list__course-percentage">
                      <v-progress-linear
                        v-model="course.progress"
                        :color="courseList[index].area_color"
                        height="25">
                      </v-progress-linear>
                      <span>{{course.progress}} %</span>
                    </v-card-actions>               
                  </v-card>
            </v-col>
              </v-row>

              <v-container fluid> 
              <v-row v-if="isAdmin && categories" class="mb-6 course-dashboard-list">
                <v-col v-for="(category,index) in categories" :key="index" cols="12" sm="6" md="4" lg="3" xl="2" class="course-dashboard-list__item">
               <v-card>             
                 <!-- :style="getCategoryStyle(category)" -->      
                      <v-card-title style="color:#fff;cursor:pointer" @click="showCategory(category)" :style="getCategoryStyle(category)" class="layout justify-center course-dashboard-list__course-title"><span>{{category.title}}</span></v-card-title>
                      <v-card-text  @click="showCategory(category)">
                          <v-card class="border-none category-details-card">
                            <v-card-text>
                              <v-layout row wrap>
                                    <v-flex xs3> <v-layout><b> {{category.areas.text}}</b></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><b> {{category.courses.text}}</b></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><b> {{category.lessons.text}}</b></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><b> {{category.codes.text}}</b></v-layout></v-flex>
                                </v-layout>
                                <br>
                                <v-layout row wrap>
                                    <v-flex xs3> <v-layout><span>{{category.areas.value}}</span></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><span>{{category.courses.value}}</span></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><span>{{category.lessons.value}}</span></v-layout></v-flex>
                                    <v-flex xs3> <v-layout><span>{{category.codes.value}}</span></v-layout></v-flex>
                                </v-layout>
                            </v-card-text>
                          </v-card>  
                      </v-card-text>
                      <v-card-actions >

                      </v-card-actions>
                </v-card>
                </v-col>
             </v-row> 

          </v-container>
          </v-container>
</template>

<script>
import axios from '../../axios-auth.js'
import {mapGetters} from 'vuex'
import MessageList from '../../elements/messages/message_list.vue'

// import colors from 'vuetify/es5/util/colors'

  export default {
    data() {
      return {
        startInit : false,
        courseList: null,
        messageList: null,
        categories: null,
        messagesShowed: true
      }
    },
    computed: 
      mapGetters([
                  'isAdmin'
      ])
    ,
    components: {
      MessageList
    },
    mounted () {
      this.startInit = true
   },
   methods: {
    initData() {
      this.startInit = false
      this.$store.commit('setBreadCrumbs',[])
      this.getMyCourses()
    },
    getMyCourses() {
      axios.get('/get-active-user-courses2', this.$store.getters.getAxiosConfig)
        .then(res => {
            this.courseList = res.data.list
            this.messageList = res.data.message_list
            /* eslint-disable no-console */
            // console.log(this.messageList)
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
      axios.get('/get-categories2', this.$store.getters.getAxiosConfig)
        .then(res => {
            this.categories = res.data.list
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)          
        })
    },
    showCategory(category) {
      this.$router.push({name:'areas', params: {id: category.category_id}})          
    },
    showCourse(course) {
      this.$router.push({name:'course_content', params: {id: course.course_id}})          
    },
    getStyle(col) {
      return "color: white; background-color: "+col+"; margin-bottom: 0.5em;";
    },
    getCategoryStyle(category) {
      return 'background-color:'+category.color+';cursor:pointer';
    },
    showMessages() {
      this.$router.push({name:'message_list', params: {}}) 
    }
   }
  }
</script>

<style>

</style>